module.exports = __webpack_public_path__ + "media/bootstrap-icons/umbrella-1b4db622.svg";